import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useSubmitForApprovalApi = (invoiceIds: number[], managerClientId: number) => {
  const call = useCallback(
    () =>
      new Promise(async (resolve, reject) => {
        try {
          const response = await axiosInstance.post('Invoice/SubmitForApproval', {
            invoiceIds,
            managerClientId,
          });
          resolve(response.data);
          return response.data;
        } catch (error) {
          console.error(error);
          reject(error);
          throw new Error(error);
        }
      }),
    [invoiceIds, managerClientId]
  );

  const { execute, isLoading, status } = useAsync(call, false);

  return {
    submitForApproval: execute,
    isSubmittingForApproval: isLoading,
    status,
  };
};

export default useSubmitForApprovalApi;
